import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../contexts/LanguageContext';
import {
    REQUEST_STATUS,
    getRequestStatusSeverity,
    getListingStatusSeverity
} from '../utils/statusBadges';

const MyPurchaseRequestsTable = ({
    data = [],
    totalRecords = 0,
    loading = false,
    pageNumber = 1,
    pageSize = 20,
    onPageChange,
    onCancelRequest
}) => {
    const { th, getCurrentLocale } = useLanguage();

    const formatDate = (value) => {
        if (!value) return '-';
        try {
            return new Date(value).toLocaleDateString(getCurrentLocale(), {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch {
            return value;
        }
    };

    const requestStatusBody = (row) => (
        <Tag
            value={row.statusText}
            severity={getRequestStatusSeverity(row.status)}
        />
    );

    const listingStatusBody = (row) => (
        <Tag
            value={row.listingStatusText}
            severity={getListingStatusSeverity(row.listingStatus)}
        />
    );

    const actionBody = (row) => {
        if (row.status === REQUEST_STATUS.PENDING) {
            return (
                <Button
                    icon="pi pi-times"
                    rounded
                    text
                    severity="danger"
                    tooltip={th('vehiclesForSale.buttons.cancelRequest')}
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => onCancelRequest?.(row)}
                />
            );
        }
        return <span className="text-500">—</span>;
    };

    const handlePageEvent = (e) => {
        const newPageNumber = Math.floor(e.first / e.rows) + 1;
        onPageChange?.({ pageNumber: newPageNumber, pageSize: e.rows });
    };

    return (
        <DataTable
            value={data}
            paginator
            lazy
            first={(pageNumber - 1) * pageSize}
            rows={pageSize}
            totalRecords={totalRecords}
            onPage={handlePageEvent}
            rowsPerPageOptions={[10, 20, 50]}
            loading={loading}
            showGridlines
            stripedRows
            responsiveLayout="scroll"
            emptyMessage={th('vehiclesForSale.emptyMessages.noRequests')}
            dataKey="requestId"
            className="p-datatable-gridlines"
        >
            <Column
                header={th('vehiclesForSale.columns.actions')}
                body={actionBody}
                style={{ minWidth: '100px', width: '100px' }}
                frozen
            />
            <Column field="chassisNo" header={th('vehiclesForSale.columns.chassisNo')} sortable style={{ minWidth: '150px' }} />
            <Column field="brand" header={th('vehiclesForSale.columns.brand')} sortable style={{ minWidth: '100px' }} />
            <Column field="model" header={th('vehiclesForSale.columns.model')} sortable style={{ minWidth: '100px' }} />
            <Column field="sellerBranchName" header={th('vehiclesForSale.columns.sellerDealer')} sortable style={{ minWidth: '200px' }} />
            <Column
                field="sellerResponseMessage"
                header={th('vehiclesForSale.labels.sellerResponseMessage')}
                body={(row) => row.sellerResponseMessage || '-'}
                style={{ minWidth: '220px' }}
            />
            <Column
                field="listingStatusText"
                header={th('vehiclesForSale.columns.listingStatus')}
                body={listingStatusBody}
                sortable
                style={{ minWidth: '140px' }}
            />
            <Column
                field="statusText"
                header={th('vehiclesForSale.columns.requestStatus')}
                body={requestStatusBody}
                sortable
                style={{ minWidth: '140px' }}
            />
            <Column
                field="createdDate"
                header={th('vehiclesForSale.columns.requestDate')}
                body={(row) => formatDate(row.createdDate)}
                sortable
                style={{ minWidth: '140px' }}
            />
            <Column
                field="decidedDate"
                header={th('vehiclesForSale.columns.decisionDate')}
                body={(row) => formatDate(row.decidedDate)}
                sortable
                style={{ minWidth: '140px' }}
            />
        </DataTable>
    );
};

export default MyPurchaseRequestsTable;
